import  { envDomain } from '@/common/contact-selector/utils/domainConfig';
export default function (params, extendConfig) {
    return new Promise((reslove, reject) => {
        const { ids } = params;
        // 说明是大组架，需要使用客户端接口
        const reqParams = { kfexts: ids.map(x => `${x}`) };
        const handler =  !extendConfig.isBigOrgApi
            ? window.Vue.prototype.$_sAjax.crossPost(`${envDomain.gateway}/v1/org/nodePathToRoot`, reqParams) : getJsBrigeData(reqParams);
        handler.then((res) => {
            if (res.code !== 0) {
                console.error('nodePathToRoot error ', res);
                reject(res);
                return;
            }

            const list = ids.map((x) => {
                let { path } = res.data.kfextPaths[x];
                path = path.map(y => y.ids.reverse());

                return {
                    id: x,
                    path,
                };
            });

            reslove(list);
        }).catch((err) => {
            reject(err);
        });
    });
}


// 新增从jsbrige拿取数据的方法
function getJsBrigeData(params) {
    return new Promise((reslove, reject) => {
        window.qdp.getOrgPathToRoot({
            key: 'getOrgPathToRoot',
            success: (res) => {
                console.log(`[JSAPI][RES][getOrgPathToRoot][res]${JSON.stringify(res)}`);
                res.code = 0;
                reslove(res);
            },
            fail: (err) => {
                reject(err);
            },
            ...params,
        });
    });
}
